import { isBrowser } from '../../shared/util/env'
import type { ThemeOptions } from './withTheme'

/** Retrieves CSS-variable value in DOM for the color name. */
export function getCSSVariableValue<T>(name: T, target?: HTMLElement): string {
    if (!isBrowser()) {
        throw new Error('Cannot use CSS variables without DOM')
    }

    const variable = `--${name}`
    const styles = window.getComputedStyle(target ?? document.documentElement)
    const value = styles.getPropertyValue(variable)

    if (!value) {
        console.warn(`Failed to get property value for var(${variable})`)
        return ''
    }

    return value.trim()
}

/** Retrieves page level theme name from <main /> element */
export function getPageThemeName() {
    if (!isBrowser()) return

    return document
        ?.querySelector('main')
        ?.getAttribute('data-theme') as ThemeOptions
}
